<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.375 11.125V13.9583C15.375 14.3341 15.2257 14.6944 14.9601
      14.9601C14.6944 15.2257 14.3341 15.375 13.9583 15.375H4.04167C3.66594
      15.375 3.30561 15.2257 3.03993 14.9601C2.77426 14.6944 2.625 14.3341
      2.625 13.9583V11.125M5.45833 7.58333L9 11.125M9 11.125L12.5417 7.58333M9 11.125L9 2.625"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>